import { SimulationService } from './../../services/simulation.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { SimulationRendererService } from '../../services/simulation-renderer.service';
import { Select } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { PredictorModelState } from '../../../state/predictor-model/predictor-model.state';
import { StudyArea } from '../../interfaces/study-area';
import { SimulationLoopService } from '../../services/simulation-loop.service';
import { SimulationState } from '../../enums/simulation-state';
import { LoopSimulationStatus as ILoopSimulationStatus } from '../../interfaces/loop-simulation-status';

@Component({
  selector: 'app-simulation-details-overlay',
  templateUrl: './simulation-details-overlay.component.html',
})
export class SimulationDetailsOverlayComponent implements OnInit, OnDestroy {
  @Select(PredictorModelState.selectedStudyArea)
  selectedStudyArea$!: Observable<StudyArea | null>;

  simulationStatus$?: Observable<ILoopSimulationStatus> = this.simulationLoopService.simulationStatus$;
  simulationStatus?: any;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  progressPercentage: number = 0;

  public simulationState = SimulationState;
  public simulationStateValue!: SimulationState;

  get isCompleted(): boolean {
    return this.simulationService.simulationState === SimulationState.Completed;
  }

  get isInLoop(): boolean {
    return this.simulationService.simulationState === SimulationState.InLoop;
  }


  ngOnInit(): void {
    this.simulationStateValue = this.simulationService.simulationState;
    this.simulationStatus$?.pipe(takeUntil(this.ngUnsubscribe)).subscribe((simulationStatus) => {
      this.simulationStatus = simulationStatus;
      this.progressPercentage = this.getSimulationProgress();
    })
  }

  constructor(
    private renderService: SimulationRendererService,
    public simulationService: SimulationService,
    public simulationLoopService: SimulationLoopService
  ) {}


  showSimulationDetails(): boolean {
    return (
      this.renderService.runDetails !== undefined &&
      this.renderService.runDetails !== null
    );
  }

  status: string = 'UNKNOWN';
  percentage: number = 0;

  getSimulationProgress(): number {
    if (this.simulationStatus?.iterations === 0) {
      return 0;
    }
    const progress: number = (this.simulationStatus?.currentIteration / this.simulationStatus?.iterations) * 100;
    return progress > 100 ? 100 : progress;
  }

  private readonly statusMap: Record<SimulationState, string> = {
    [SimulationState.Running]: 'In-Progress',
    [SimulationState.InLoop]: 'In-Progress',
    [SimulationState.Paused]: 'Paused',
    [SimulationState.Completed]: 'Completed',
    [SimulationState.Ready]: '',
    [SimulationState.Failed]: 'Failed',
  };

 getStatus(): string {
    if(this.simulationService.isFinishclicked && this.statusMap[this.simulationService.simulationState]==this.statusMap[SimulationState.Paused]){
      return this.statusMap[this.simulationState.Running]
    }
    else if( this.statusMap[this.simulationState.Completed]==this.statusMap[this.simulationService.simulationState]){
      this.simulationService.isFinishclicked = false;
      return this.statusMap[this.simulationState.Completed]
    }
    else  
      return this.statusMap[this.simulationService.simulationState] || '';
   
  }
 
  formatTime(timeInMs: number): string {
    const msInSecond: number = 1000;
    const msInMinute: number = 60000;
    const msInHour: number = 3600000;

    if (timeInMs < msInSecond) {
      return `${Math.floor(timeInMs)} ms`;
    }

    const seconds: number = Math.floor((timeInMs % msInMinute) / msInSecond);
    const minutes: number = Math.floor((timeInMs % msInHour) / msInMinute);
    const hours: number = Math.floor(timeInMs / msInHour);

    if (timeInMs < msInMinute) {
      return `${Math.floor(timeInMs / msInSecond)} s`;
    }

    if (timeInMs < msInHour) {
      return `${minutes} min ${seconds} s`;
    }

    return `${hours} h ${minutes} min ${seconds} s`;
  }
}
